/* GOLDSQUARE - product card hover gallery

   Scrub across a card's image to move through every photo the product
   has. Left edge is the first image, right edge the last.

   Why pointer position rather than a timed auto-cycle: a timer makes
   the shopper wait for the photo they want and re-starts every time the
   mouse re-enters. Scrubbing is instant and reversible, and it maps the
   whole set onto the width of the card so nothing is more than one
   movement away.

   Touch has no hover at all, so the indicator bars double as buttons.
*/

(function () {
  'use strict';

  function initCard(card) {
    var media = card.querySelector('.pcard__media');
    var imgs  = card.querySelectorAll('[data-card-img]');
    var dots  = card.querySelectorAll('[data-card-dot]');
    if (!media || imgs.length < 2) return;

    var active = 0;

    function show(i) {
      if (i === active || i < 0 || i >= imgs.length) return;

      imgs[active].classList.remove('is-active');
      imgs[active].setAttribute('aria-hidden', 'true');
      if (dots[active]) {
        dots[active].classList.remove('is-active');
        dots[active].removeAttribute('aria-current');
      }

      active = i;

      imgs[active].classList.add('is-active');
      imgs[active].removeAttribute('aria-hidden');
      if (dots[active]) {
        dots[active].classList.add('is-active');
        dots[active].setAttribute('aria-current', 'true');
      }
    }

    media.addEventListener('pointermove', function (e) {
      // Touch and pen already have the dots; scrubbing on a finger
      // would fight the carousel's horizontal swipe.
      if (e.pointerType !== 'mouse') return;
      var rect = media.getBoundingClientRect();
      if (!rect.width) return;
      var ratio = (e.clientX - rect.left) / rect.width;
      var index = Math.floor(ratio * imgs.length);
      if (index < 0) index = 0;
      if (index > imgs.length - 1) index = imgs.length - 1;
      show(index);
    });

    // Always rest on the hero shot, so a grid never ends up showing a
    // row of different-looking cards after the cursor passes over.
    media.addEventListener('pointerleave', function () { show(0); });

    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(i);
      });
      // Keyboard users tab onto a bar and the image follows.
      dot.addEventListener('focus', function () { show(i); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-card-gallery]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
